import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-customer-disc-grp-prod',
  templateUrl: './customer-disc-grp-prod.component.html',
  styleUrls: ['./customer-disc-grp-prod.component.css']
})
export class CustomerDiscGrpProdComponent implements OnInit {
    custNo;

    public inputListCustomerDiscounts: CustomerDiscountItem[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.custNo = this.stateService.getStateParams()['cust_no'];
    }

    private async loadCustomerDiscounts() {
        if (!!this.custNo) {
            this.inputListCustomerDiscounts = await this.datatask.Post(304, { cust_no: this.custNo });
        }
    }

    private async init() {
        this.loadCustomerDiscounts();
    }

    ngOnInit() {
        this.init();
    }
}

interface CustomerDiscountItem {
    discgrpprod_keyno: number;
    discgrpprod_name: string;
    pst: string;
}
